import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-order-summary',
  standalone: false,
  templateUrl: './order-summary.component.html',
  styleUrl: './order-summary.component.scss',
})
export class OrderSummaryComponent {
  @Input() title = 'Basket';

  @Input() cartItems: any[] = [];
  @Input() orderNotes = '';
  @Input() isEditingNotes = false;
  @Input() orderNotesDraft = '';

  @Input() serviceFee = 0;
  @Input() deliveryFee = 0;
  @Input() smallOrderFee = 0;
  @Input() total = 0;
  @Input() isDelivery = false;

  @Input() editableNotes = true;

  @Output() startEditNotes = new EventEmitter<void>();
  @Output() cancelEditNotes = new EventEmitter<void>();
  @Output() saveNotes = new EventEmitter<void>();
  @Output() orderNotesDraftChange = new EventEmitter<string>();
}
